if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.slide-image').slick({
        accessibility: false
    });

    $('.slide-text').slick({
        accessibility: false
    });

    $('.slider-home').slick({
        accessibility: true,
        arrows: false,
        slidesToShow: 1,
        speed: 1000,
        fade: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: false
                }
            }
        ]
    });
    
    $(".rooms__image").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    $(".slider__image").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        asNavFor: '.slider__text',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots:true
                }
            },
        ]
    });
    $(".slider__text").slick({
        infinite: true,
        speed: 1000,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.slider__image',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    adaptiveHeight: true,
                    dots: false,
                }
            },
        ]

    });
    $(".rooms-overview__image").slick({
        accessibility: true,
        speed: 1000,
        dots: true,
        autoplay: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {

                    arrows: false
                }
            }
        ]

    });
    $(".gallery-block__featured").slick({
        speed: 1000,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.gallery-block__list',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    variableWidth: true

                }
            },
            {
                breakpoint: 600,
                settings: {
                }
            },
        ]

    });

    $(".gallery-block__list").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        dots: true,
        centerMode: true,
        asNavFor: '.gallery-block__featured',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true
                }
            },
        ]

    });

    $(".reviews__slider").slick({
        accessibility: true,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        centerMode: true,
        fade: true,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    autoplay: false
                }
            }
        ]
    });

    // Location Module Template
    $(".map__items li").hover(
        function () {
            var target = $(this).data("id");
            $("#" + target).addClass("hover");
        },
        function () {
            var target = $(this).data("id");
            $("#" + target).removeClass("hover");
        }
    );
    $(".dot__item").hover(
        function () {
            var target = $(this).attr("id");
            $(".map__items li[data-id=" + target + "]").addClass("hover");
        },
        function () {
            var target = $(this).attr("id");
            $(".map__items li[data-id=" + target + "]").removeClass("hover");
        }
    );
    $(".dot__item").click(
        function () {
            $('.open').not(this).removeClass('open');
            var target = $(this).attr("id");
            $(".map__item[data-id=" + target + "]").toggleClass("open");
        }
    );
    $(".map__close").click(
        function (e) {
            $(this).parent().removeClass("open");
            e.stopPropagation();
        }
    );
    $(".map__items li").click(
        function () {
            $('.open').not(this).removeClass('open');
            var target = $(this).data("id");
            $(".map__item[data-id=" + target + "]").toggleClass("open");
        }
    );

    // MOBILE MENU FUNCTIONALITY
    // Hover on desktop, click on mobile
    let navLinks = document.querySelectorAll('#primary-nav li a.toggle-menu');  

    if(window.screen.width < 640) {
        window.addEventListener('load', () => {
            navLinks.forEach( link => {
                const parent = link.parentNode;
                let submenu = parent.querySelector('.submenu')
                submenu.style.display = "none";
            });
        })

        navLinks.forEach( link => {
            link.addEventListener( 'click', (e) => {
                e.preventDefault();
                const parent = link.parentNode;
                let submenu = parent.querySelector('.submenu')           
                
                if(link.classList.contains('hover')){
                    console.log({submenu});
                    link.classList.remove('hover')
                    submenu.style.display ="none"
                    
                } else {
                    link.classList.add('hover')
                    submenu.style.display ="block"
                }                  
            });
        })
    } $(document).ready(function () {
        if (window.screen.width > 640) {
            $("#primary-nav li").click(function ( e ) {
               if( e.target.parentNode.parentNode.id == 'privary-navigation' && e.target.nextElementSibling.nodeName == "UL"){
                   e.preventDefault();
                    var $submenu = $('ul.submenu', this);
                    if ($(this).hasClass('active')) {
                        location.replace(`${e.target.href}`);
                        /* $(this).removeClass('active');
                        $submenu.fadeOut(1000); */
                    } else {
                        $("#primary-nav li.active").removeClass('active').find('ul.submenu').fadeOut(1000);
                        $(this).addClass('active');
                        $submenu.fadeIn(200);
                    }
               }
            });
        }
    });


    if (document.querySelector('label[for="id_11_2806_txt"]')) {
        let label_form_upload = document.querySelector('label[for="id_11_2806_txt"]');
        label_form_upload.classList.remove('hidden');
    }
   
    //placehorder for input date mobile
    $("input[type=date],input[type=time]").on("input", function () {
        if ($(this).val().length > 0) {
            $(this).addClass("full");
        } else {
            $(this).removeClass("full");
        }
    });

    if(document.getElementById("fsCountdown")){
        const fsCountdown = new Date(document.getElementById('fsCountdown').getAttribute('data-time'));
          //countdown
          let fsDays = 0;
          let fsHours = 0;
          let fsMinutes = 0;
          let fsSeconds = 0;
          tick();
          let fsTimer = setInterval(tick.bind(this), 1000);
       
        function updateRemaining(fsDistance) {
          fsDays = Math.floor(fsDistance / (1000 * 60 * 60 * 24));
          fsHours = Math.floor((fsDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + 5;
          fsMinutes = Math.floor((fsDistance % (1000 * 60 * 60)) / (1000 * 60)) - 1;
          fsSeconds = Math.floor((fsDistance % (1000 * 60)) / 1000);
      
          document.getElementById('fsDays').innerHTML = fsDays;
          document.getElementById('fsHours').innerHTML = fsHours;
          document.getElementById('fsMinutes').innerHTML = fsMinutes;
          document.getElementById('fsSeconds').innerHTML = fsSeconds;
        }
        function tick() {
          const currentTime = new Date();
          const fsDistance = Math.max(fsCountdown - currentTime, 0);
          updateRemaining(fsDistance);
          
          if (fsDistance === 0) {
            clearInterval(fsTimer);
          }
        };
      }
  

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
    const menu = document.querySelector('.navigation');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .bookNow');
    const closeMenuButton = document.querySelector('.close-menu');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });

    const elementsToHide = document.querySelectorAll('.menu-cta__logo a, .phone a, .menu-cta__booking .booking-cta, .cleanliness-badge a');
    elementsToHide.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '-1' : '0');
    });

    closeMenuButton.addEventListener('click', () => {
        const firstHeaderElement = header.querySelector('.phone a');
        if (firstHeaderElement){
            firstHeaderElement.focus();
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.navigation');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});


